import * as React from 'react';

/**
 * Whether the window matches a CSS media query, kept up to date as the window is resized.
 * Where there is no way to ask (a test), it matches.
 */
export const useMediaQuery = (query: string) : boolean => {

    const canMatch = typeof window !== 'undefined' && typeof window.matchMedia === 'function';
    const [matches, setMatches] = React.useState<boolean>(() => canMatch ? window.matchMedia(query).matches : true);

    React.useEffect(() => {

        if (!canMatch) {
            return;
        }

        const list = window.matchMedia(query);
        const onChange = () => setMatches(list.matches);

        onChange();

        // Safari before 14 only knows the older way of listening
        if (list.addEventListener) {
            list.addEventListener('change', onChange);
            return () => list.removeEventListener('change', onChange);
        }

        list.addListener(onChange);
        return () => list.removeListener(onChange);

    }, [query]);

    return matches;
};
